export default __webpack_public_path__ + "static/media/Logo.9abcc661.svg";